import { css } from '@emotion/css';

export const loader = css`
	display: flex;
	justify-content: center;
	align-items: center;
	position: fixed;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
	background: #bfbfbf4f;
	z-index: 100;
`;
